interface DrawerErrorStateProps {
  label: string;
}

export function DrawerErrorState({ label }: DrawerErrorStateProps) {
  return (
    <div className="my-10 flex h-full w-full flex-col items-center justify-center">
      <div>Sorry, there was a problem loading this {label}.</div>
      <div className="mt-1.5 text-xs text-gray-500">
        Please try again, or contact{' '}
        <a href="mailto:support@wexler.ai" className="text-blue-500">
          support@wexler.ai
        </a>{' '}
        if the issue persists.
      </div>
    </div>
  );
}
